export default __webpack_public_path__ + "static/media/2008.83f4c53b.png";